<template>
  <el-dialog
    title="在线留言"
    :visible.sync="visible"
    width="896px"
    class="dialog"
    append-to-body
    :close-on-click-modal="false"
    @open="handleOpen"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="留言类型" prop="messageType">
        <el-select
          v-model="form.messageType"
          placeholder="请选择留言类型"
          style="width: 100%"
        >
          <el-option
            :label="item.dictLabel"
            :value="item.dictValue"
            v-for="(item, index) in messageTypeOptions"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位名称" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入单位名称"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item label="用户姓名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入姓名" clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="电话" prop="userPhone">
        <el-input v-model="form.userPhone" placeholder="请输入电话" clearable>
        </el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="userEmail">
        <el-input
          v-model="form.userEmail"
          placeholder="请输入邮箱，回复内容将以邮件的方式发至您的邮箱"
          clearable
        >
        </el-input>
      </el-form-item>

      <el-form-item label="留言内容" prop="messageContent">
        <el-input
          v-model="form.messageContent"
          type="textarea"
          placeholder="请输入留言内容"
          show-word-limit
          :rows="4"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="loading"
        >确定</el-button
      >
      <el-button @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { leaveMessage } from "@/api/common";
import { ONLINE_CONSULT_TYPE } from "@/constant/dict";

export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //在线留言类型
      messageTypeOptions: [],
      form: {
        messageType: "",
        messageContent: "",
        companyName: "",
        userName: "",
        userPhone: "",
        userEmail: "",
      },
      rules: {
        messageType: [
          { required: true, message: "请选择留言类型", trigger: "change" },
        ],
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        userPhone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        messageContent: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
        // userEmail: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    this.getDict();
  },
  methods: {
    async getDict() {
      this.messageTypeOptions = await this.$store.dispatch(
        "getDictData",
        ONLINE_CONSULT_TYPE
      );
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
      });
    },

    async submitForm() {
      await this.$refs.ruleForm.validate();
      this.loading = true;
      await this.$axios.post(leaveMessage, this.form).finally(() => {
        this.loading = false;
      });
      this.$message.success("留言成功");
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    border-radius: 12px;
  }
  .el-dialog__header {
    padding: 20px 24px;
    background: #f7f7f7;
    border-radius: 12px 12px 0 0;
  }
  .el-dialog__title {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
  }
  .el-dialog__headerbtn {
    top: 20px;
    right: 24px;
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-form-item {
    margin-bottom: 24px;
  }
}
</style>
